import { PaxInfoModal } from '@vueling-ng/vy-cdk-searcher';

export type PaxInfoLabels =
  | 'GroupsWarning'
  | 'MaxPax'
  | 'ExtraSeatReservationMinDays'
  | 'Children'
  | 'Infants'
  | 'ExtraSeats';
export const PaxInfoLabelsValues: PaxInfoLabels[] = [
  'GroupsWarning',
  'MaxPax',
  'ExtraSeatReservationMinDays',
  'Children',
  'Infants',
  'ExtraSeats'
];

export const modalLabelsDictionary: Record<PaxInfoLabels, PaxInfoModal> = {
  GroupsWarning: {
    closeButton: 'cdk.searcher.pax.informativeModals.groupsWarning.closeButton',
    content: 'cdk.searcher.pax.informativeModals.groupsWarning.content',
    title: 'cdk.searcher.pax.informativeModals.groupsWarning.title'
  },
  MaxPax: {
    closeButton: 'cdk.searcher.pax.informativeModals.extraSeatWarning.closeButton',
    content: 'cdk.searcher.pax.informativeModals.extraSeatWarning.content',
    title: 'cdk.searcher.pax.informativeModals.extraSeatWarning.title'
  },
  ExtraSeatReservationMinDays: {
    closeButton: 'cdk.searcher.pax.informativeModals.extraSeatBeforePermittedDays.closeButton',
    content: 'cdk.searcher.pax.informativeModals.extraSeatBeforePermittedDays.content',
    title: 'cdk.searcher.pax.informativeModals.extraSeatBeforePermittedDays.title'
  },
  Children: {
    closeButton: 'cdk.searcher.pax.informativeModals.childrenTravellingAlone.closeButton',
    content: 'cdk.searcher.pax.informativeModals.childrenTravellingAlone.content',
    title: 'cdk.searcher.pax.informativeModals.childrenTravellingAlone.title'
  },
  Infants: {
    closeButton: 'cdk.searcher.pax.informativeModals.flyingWithInfants.closeButton',
    content: 'cdk.searcher.pax.informativeModals.flyingWithInfants.content',
    title: 'cdk.searcher.pax.informativeModals.flyingWithInfants.title'
  },
  ExtraSeats: {
    closeButton: 'cdk.searcher.pax.informativeModals.extraSeatMoreInfo.closeButton',
    content: 'cdk.searcher.pax.informativeModals.extraSeatMoreInfo.content',
    title: 'cdk.searcher.pax.informativeModals.extraSeatMoreInfo.title'
  }
};
